import { isGa4Enabled } from './site';

/**
 * Run a tracker. Analytics must never break the page it measures, nor strand a
 * user waiting on `onFailure` — every tracker sits on a booking, payment or
 * sign-in path. With GA4 off the tracker never runs, so no payload is built
 * and no skip is logged, and `onFailure` still settles the caller.
 */
export function safely(track: () => void, onFailure?: () => void): void {
  if (!isGa4Enabled()) {
    onFailure?.();
    return;
  }
  try {
    track();
  } catch {
    onFailure?.();
  }
}
